<template>
  <div
    v-if="show"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4"
    @click.self="$emit('close')"
  >
    <div
      class="bg-white rounded-2xl max-w-md w-full p-6 relative animate-fade-in"
    >
      <!-- Close button -->
      <button
        @click="$emit('close')"
        class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
      >
        <svg
          class="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>

      <!-- Icon -->
      <div class="flex justify-center mb-4">
        <div
          class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center"
        >
          <svg
            class="w-8 h-8 text-red-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
            ></path>
          </svg>
        </div>
      </div>

      <!-- Title -->
      <h3 class="text-xl font-semibold text-gray-900 text-center mb-2">
        Account Not Found
      </h3>

      <!-- Message -->
      <div class="text-center mb-6">
        <p class="text-gray-600 mb-2">No account found with email:</p>
        <p
          class="font-medium text-gray-900 bg-gray-50 px-3 py-2 rounded-lg inline-block"
        >
          {{ email }}
        </p>
        <p class="text-gray-600 mt-3">
          Please register first or contact support if you believe this is an
          error.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
  defineProps({
    show: {
      type: Boolean,
      default: false,
    },
    email: {
      type: String,
      default: "",
    },
  });

  defineEmits(["close"]);
</script>

<style scoped>
  .animate-fade-in {
    animation: fadeIn 0.2s ease-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
</style>
